import { Observable } from 'rxjs';
import { CreateProblemReportRequest, ProblemReportCreated, ReportAttachment } from 'src/app/global/components/dialogs/report-problem-dialog/report-problem.model';

export abstract class ReportProblemService {
    abstract uploadAttachment(file: File): Observable<ReportAttachment>;
    abstract create(report: CreateProblemReportRequest): Observable<ProblemReportCreated>;
}
